export default "__VITE_ASSET__DT1Pd58l__"